module.exports = __webpack_public_path__ + "static/media/session-info-image.f48c5534.svg";